import { lazy, useEffect, Suspense, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import "./style/navbar/navbar.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import FooterContainer from "./features/FooterContainer/FooterContainer";
import BackToTop from "./components/BackToTop";
import FloatingContainer from "./features/FloatingContainer/FloatingContainer";
import "font-awesome/css/font-awesome.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingComponent from "./pages/LoadingPage";
import ContactUs from "./pages/ContactUs";

function App() {
  useEffect(() => {
    AOS.init({
      once: true, 
    });
  }, []);

  const HomePage = lazy(() => import("./features/HomeContainer/HomeContainer"));
  const DestinationsPage = lazy(() =>
    import("./features/DestinationsContainer/DestinationsContainer")
  );
  const ExperiencesPage = lazy(() =>
    import("./features/ExperiencesContainer/ExperiencesContainer")
  );
  const AboutPage = lazy(() =>
    import("./features/AboutContainer/AboutContainer")
  );
  const ServicesPage = lazy(() =>
    import("./features/ServicesContainer/ServicesContainer")
  );
  const QuizContainer = lazy(() =>
    import("./features/QuizContainer/QuizContainer")
  );
  const LoadingPage = lazy(() => import("./pages/LoadingPage"));

  function TimedFallbackWrapper({ children, delay = 500, minShowTime = 3000 }) {
    const [showFallback, setShowFallback] = useState(false);
    const [doneLoading, setDoneLoading] = useState(false);

    useEffect(() => {
      // Step 1: wait before showing fallback (optional)
      const delayTimer = setTimeout(() => setShowFallback(true), delay);

      return () => clearTimeout(delayTimer);
    }, [delay]);

    useEffect(() => {
      if (showFallback) {
        // Step 2: enforce minimum display time for fallback
        const minTimer = setTimeout(() => setDoneLoading(true), minShowTime);
        return () => clearTimeout(minTimer);
      }
    }, [showFallback, minShowTime]);

    if (!showFallback) {
      // still in delay period (e.g., <500ms)
      return null;
    }

    if (!doneLoading) {
      // show fallback for at least minShowTime
      return <LoadingComponent />;
    }

    // after minShowTime, render children (Suspense content)
    return children;
  }

  return (
    <div>
      <Navbar />
      {/* <TimedFallbackWrapper delay={500} minShowTime={3000}> */}
        <Suspense fallback={<LoadingComponent />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route
              path="/experiences"
              element={<ExperiencesPage />}
            />
            <Route
              path="/destinations"
              element={<DestinationsPage />}
            />
            <Route
              path="/services"
              element={<ServicesPage />}
            />
            <Route
              path="/quiz"
              element={<QuizContainer />}
            />
            <Route
              path="/contact"
              element={<ContactUs />}
            />
            <Route
              path="/*"
              element={<Navigate to="/" replace />}
            />
          </Routes>
        </Suspense>
        <FooterContainer />
      {/* </TimedFallbackWrapper> */}
      <BackToTop />
      <FloatingContainer />
      <ToastContainer />
    </div>
  );
}

export default App;
